import { IncomingMessage, ServerResponse } from 'http';
import { NextPageContext } from 'next';
import { run } from '../../common/util/run';

export class PreloadJob {
  constructor(public context: NextPageContext) {}

  services = run(() => {
    if (!this.context.services) throw new Error('No Services provided through page context');
    return this.context.services;
  });

  server =
    (!process.browser &&
      this.context.req &&
      this.context.res &&
      new PreloadJobServer(this.context.req, this.context.res)) ||
    undefined;
}

export class PreloadJobServer {
  constructor(public req: IncomingMessage, public res: ServerResponse) {}
}
